module.exports = __webpack_public_path__ + "static/media/cockroach(20).dd38e11c.PNG";